import { MappedProductSearchParams, ProductSearchParams, SortOption } from '../types';

const sortToIndexMap: Record<SortOption, string> = {
  most_relevant: 'shopify_products',
  'created-descending': 'shopify_products_published_at_desc',
  'created-ascending': 'shopify_products_published_at_asc',
  'title-ascending': 'shopify_products_title_asc',
  'title-descending': 'shopify_products_title_desc',
  'price-ascending': 'shopify_products_price_asc',
  'price-descending': 'shopify_products_price_desc',
  '': 'shopify_products',
};

function getIndexForSort(sortOption: SortOption): string {
  return sortToIndexMap[sortOption];
}

const autocompleteRequest = (query?: string) => ({
  indexName: 'shopify_products_query_suggestions',
  query,
});

export const mapToSearchParams = (params: ProductSearchParams): MappedProductSearchParams[] => {
  const facetFilterRequests: MappedProductSearchParams[] = [];
  const {
    query,
    filters,
    facetFilters = [],
    hitsPerPage,
    facets = [],
    sumOrFiltersScores,
    sortBy,
    page,
    optionalFilters,
    enableAutocomplete,
    userToken,
    enablePersonalization,
    typoTolerance,
    restrictSearchableAttributes,
  } = params;

  const indexName = getIndexForSort(sortBy || 'most_relevant');

  const baseRequest: MappedProductSearchParams = {
    indexName,
    query,
    hitsPerPage: hitsPerPage || 10,
    facets,
    facetFilters,
    sumOrFiltersScores,
    filters,
    page: page || 0,
    optionalFilters,
    userToken,
    clickAnalytics: true,
    enablePersonalization,
    typoTolerance,
    restrictSearchableAttributes,
  };

  // Extract unique facet keys from filters (e.g. "vendor", "option_colour")
  const facetTypes = Array.from(
    new Set(
      facetFilters
        .flat()
        .map((filter: string) => filter.split(':')[0])
        .filter(Boolean),
    ),
  );

  facetTypes.forEach((facetType) => {
    const otherFacetFilters = facetFilters.filter(
      (filter: string[]) => filter[0].split(':')[0] !== facetType,
    );

    facetFilterRequests.push({
      indexName,
      query,
      hitsPerPage: 0,
      facets: [facetType], // Just this facet group
      facetFilters: otherFacetFilters,
      sumOrFiltersScores,
      filters,
    });
  });

  return [
    baseRequest,
    ...facetFilterRequests,
    ...(enableAutocomplete ? [autocompleteRequest(query)] : []),
  ];
};
